import React, { useState } from "react";
import { Col, message, Row, Select } from "antd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import "./style.css";
import { fileCompress, getBase64 } from "../../../Utils";
import { CustomLabel } from "../../../Common/style";
import { UploadInput } from "../../../Components/UploadInput";
import {
  Document_key,
  kyc_document,
  uploadStatus_Key,
} from "../../../Constant";
import { PolicyDetails } from "../CommonData";
import FooterButton from "../../Footer";
import { useEffect } from "react";
import { postApi, postUploadDocument } from "../../../Services/apiService";
import { UPLOAD_DOCUMENT } from "../../../Services/endpoints";
import { useNavigate } from "react-router-dom";
import { withScroll } from "../../../HOC/withScroll";

const UploadPage = () => {
  const navigate = useNavigate();
  let { kycDetails, applicationID, policyNum, renewalYear, customerId, localApplicationNumber, localPolicyNumber } = PolicyDetails();
  const isPolicyNum = !!(localPolicyNumber && !localApplicationNumber);

  if (!kycDetails) {
    kycDetails = [
      {
        DocCategoryCd: "IDENTITYPROOF",
        DocumentCd: "IDENTITYPROOF",
        ReceivedStatusCd: "PENDING",
        Frontend_msg: "Please upload valid identity proof ",
      },
      {
        DocCategoryCd: "KYCADDRESSPROOF",
        DocumentCd: "ADDRESSPROOF",
        ReceivedStatusCd: "PENDING",
        Frontend_msg: "Please upload valid Address proof",
      },
      {
        DocCategoryCd: "PHOTO",
        DocumentCd: "PHOTO",
        ReceivedStatusCd: "PENDING",
        Frontend_msg: "Please upload valid Photograph",
      },
    ];
  }
  const cardToShow = kycDetails.map((ei) => ei.DocCategoryCd);

  const statusToCheck = [
    "COMPLETED",
    "RECEIVED",
    "APPROVED",
    "DIGITALAPPROVED",
  ];
  const checkRequirementOfDocs = (type) => {
    let res = kycDetails.find((ei) => {
      if (type === ei.DocCategoryCd) {
        return !statusToCheck.includes(ei.ReceivedStatusCd);
      }
    });
    return !!res;
  };

  const [documentDocs, setDocument] = useState({
    ...(cardToShow.includes("PHOTO") && checkRequirementOfDocs("PHOTO")
      ? { photo: [] }
      : {}),
    ...(cardToShow.includes("IDENTITYPROOF") &&
    checkRequirementOfDocs("IDENTITYPROOF")
      ? { identity: [] }
      : {}),
    ...(cardToShow.includes("KYCADDRESSPROOF") &&
    checkRequirementOfDocs("KYCADDRESSPROOF")
      ? { kycdocs: [] }
      : {}),
  });

  const [selectDocs, setSelectDocs] = useState({
    ...(cardToShow.includes("PHOTO") && checkRequirementOfDocs("PHOTO")
      ? { photo: "" }
      : {}),
    ...(cardToShow.includes("IDENTITYPROOF") &&
    checkRequirementOfDocs("IDENTITYPROOF")
      ? { identity: "" }
      : {}),
    ...(cardToShow.includes("KYCADDRESSPROOF") &&
    checkRequirementOfDocs("KYCADDRESSPROOF")
      ? { kycdocs: "" }
      : {}),
  });

  const { photo, identity, kycdocs } = documentDocs;
  const [showUploadButton, setShowUploadButton] = useState(true);

  const onRemove = (idx) => {
    const filterData = photo.filter((ele) => {
      return ele.key != idx;
    });
    setDocument({ ...documentDocs, ...{ photo: filterData } });
    // setFiles(filterData);
  };

  const uploadDocs = ({ typeOfDocs, subDocType, docType, files }) => {
    const resOfData = uploadStatus_Key(typeOfDocs, subDocType);

    const { Docs_type, Sub_docs } = resOfData;
    let customObj = {
      DocumentClass: "ProposalDocuments",
      DocumentType: Docs_type,
      SubDocType: Sub_docs,
      RenewalYear: renewalYear,
      SourceName: "LR",
      ApplicationNumber: isPolicyNum ? policyNum : applicationID,
      DocCategoryTypeCd: "CHECKLIST",
      DocCategoryCd: typeOfDocs,
      DocumentCd: subDocType,
      StatusCd: "RECEIVED",
      LifeRayMemberId: null,
      CustomerId: customerId,
      files: files,
    };
    return customObj;
  };

  const onUpload = async () => {
    let obj = {};
    let files;
    setTimeout(() => {
      document.body.classList.remove("loading-indicator-api");
      navigate("/thankyou", { replace: true });
    }, 10000);
    await Promise.all(
      Object.keys(selectDocs).map((ei) => {
        switch (ei) {
          case "photo":
            files = documentDocs.photo;
            obj = uploadDocs({
              typeOfDocs: "PHOTO",
              subDocType: "PHOTO",
              docType: "photo",
              files: files,
            });
            postUploadDocument({ ...obj });
            break;
          case "identity":
            files = documentDocs.identity;
            obj = uploadDocs({
              typeOfDocs: "IDENTITYPROOF",
              subDocType: selectDocs.identity,
              docType: "identity",
              files: files,
            });
            postUploadDocument({ ...obj });
            break;
          case "kycdocs":
            files = documentDocs.kycdocs;
            obj = uploadDocs({
              typeOfDocs: "KYCADDRESSPROOF",
              subDocType: selectDocs.kycdocs,
              docType: "kycdocs",
              files: files,
            });
            postUploadDocument({ ...obj });
            break;
        }
      })
    );
  };

  const handleUploadPhoto = async (file, key) => {
    if (selectDocs.photo === "") {
      return message.error("Please select document type");
    }
    try {
      file = await fileCompress(file);
    } catch (err) {
      console.error(err);
    }

    getBase64(file, async (base64) => {
      const copy = [...photo, { base64, key, file, filename: file.name }];
      setDocument({ ...documentDocs, ...{ photo: copy } });
    });
  };

  const onRemoveIdentity = (idx) => {
    const filterData = identity.filter((ele) => {
      return ele.key != idx;
    });
    setDocument({ ...documentDocs, ...{ identity: filterData } });
    // setFiles(filterData);
  };

  const handleUploadIdentity = async (file, key) => {
    if (selectDocs.identity === "") {
      return message.error("Please select document type");
    }
    try {
      file = await fileCompress(file);
    } catch (err) {
      console.error(err);
    }
    console.log("handleUploadIdentity", file);
    getBase64(file, async (base64) => {
      const copy = [
        ...identity,
        {
          base64,
          key,
          file,
          filename: file.name,
        },
      ];
      setDocument({ ...documentDocs, ...{ identity: copy } });
      // setFiles(copy);
    });
  };

  const onRemoveKyc = (idx) => {
    const filterData = kycdocs.filter((ele) => {
      return ele.key != idx;
    });
    setDocument({ ...documentDocs, ...{ kycdocs: filterData } });
    // setFiles(filterData);
  };

  const onSelectClick = (val, name) => {
    setSelectDocs({ ...selectDocs, ...{ [name]: val } });
  };

  const handleUploadKyc = async (file, key) => {
    if (selectDocs.kycdocs === "") {
      return message.error("Please select document type");
    }
    try {
      file = await fileCompress(file);
    } catch (err) {
      console.error(err);
    }
    getBase64(file, async (base64) => {
      const copy = [
        ...kycdocs,
        {
          base64,
          key,
          file,
          filename: file.name,
        },
      ];
      setDocument({ ...documentDocs, ...{ kycdocs: copy } });
      // setFiles(copy);
    });
  };

  useEffect(() => {
    setShowUploadButton(
      Object.values(documentDocs)
        .map((ei) => ei.length > 0)
        .includes(false)
    );
  }, [documentDocs]);

  return (
    <div className="container upload-card-wrapper">
      <Row style={{ width: "100%" }}>
        <Col span={24} style={{ marginTop: "40px" }}>
          <CustomLabel font_size="32">Document Upload</CustomLabel>
        </Col>
        <Col>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "20px 0px",
            }}
          >
            <CustomLabel font_weight={"normal"}>
              You can upload the documents in pdf, jpg, jpeg, png formats only.{" "}
              <br />
              Maximum size limit is 3MB.<br />
              {/* Uploading is a fastest way of getting the documents sent to our
              team. In case you are not able to upload.<br /> */}
            </CustomLabel>
          </div>
        </Col>
        {checkRequirementOfDocs("PHOTO") && (
          <Col span={24}>
            <div style={{ margin: "10px" }}>
              <CustomLabel>{Document_key("PHOTO")}</CustomLabel>
            </div>
            <SectionCardWrapper>
              <div style={{ marginBottom: "22px" }}>
                <CustomLabel
                  style={{ display: "block", paddingBottom: "12px" }}
                  font_size="14"
                >
                  Select any of the following documents
                </CustomLabel>
                <Select
                  // defaultValue={kyc_document.photo[0].value}
                  placeholder="Select below option"
                  style={{ minWidth: "120px" }}
                  // value={value.opdValue}
                  onChange={(val) => onSelectClick(val, "photo")}
                  options={kyc_document.photo}
                ></Select>
              </div>
              <div className="upload-card-wrapper">
                <UploadInput
                  onUpload={(e) => handleUploadPhoto(e, photo.length)}
                  style={{ margin: "0px 20px 0px 20px " }}
                  disabled={photo.length >= 1}
                  title={
                    photo.length !== 1 ? "Attach" : "you have uploaded max docs"
                  }
                />
                <div className="upload-card-wrapper">
                  {photo.map((item, i) => {
                    return (
                      <UploadInput
                        style={{ margin: "0px 10px 0px 0px " }}
                        title={item.filename}
                        value={item}
                        onRemove={onRemove}
                        hideRemoveBtn={false}
                        hideFileName={false}
                        doc_key={item.key}
                        key={"photo-" + i}
                      />
                    );
                  })}
                </div>
              </div>
            </SectionCardWrapper>
          </Col>
        )}
        {/* {-----------------------------------------------------------------------------------------------} */}
        {checkRequirementOfDocs("IDENTITYPROOF") && (
          <Col span={24}>
            <div style={{ margin: "10px" }}>
              <CustomLabel>{Document_key("IDENTITYPROOF")}</CustomLabel>
            </div>
            <SectionCardWrapper>
              <div style={{ marginBottom: "22px" }}>
                <CustomLabel
                  style={{ display: "block", paddingBottom: "12px" }}
                  font_size="14"
                >
                  Select any of the following documents
                </CustomLabel>
                <Select
                  // defaultValue={kyc_document.IDENTITYPROOF[0].value}
                  placeholder="Select below option"
                  style={{ minWidth: "120px" }}
                  options={kyc_document.IDENTITYPROOF}
                  onChange={(val) => onSelectClick(val, "identity")}
                ></Select>
              </div>
              <div className="upload-card-wrapper">
                <UploadInput
                  onUpload={(e) => handleUploadIdentity(e, identity.length)}
                  style={{ margin: "0px 20px 0px 20px " }}
                  disabled={identity.length >= 3}
                  title={
                    identity.length !== 3
                      ? "Attach"
                      : "you have uploaded max docs"
                  }
                />
                <div className="upload-card-wrapper">
                  {identity.map((item, i) => {
                    return (
                      <UploadInput
                        style={{ margin: "0px 10px 0px 0px " }}
                        title={item.filename}
                        value={item}
                        hideRemoveBtn={false}
                        onRemove={onRemoveIdentity}
                        hideFileName={false}
                        doc_key={item.key}
                        key={"identity" + i}
                      />
                    );
                  })}
                </div>
              </div>
            </SectionCardWrapper>
          </Col>
        )}
        {checkRequirementOfDocs("KYCADDRESSPROOF") && (
          <Col span={24}>
            <div style={{ margin: "10px" }}>
              <CustomLabel>{Document_key("KYCADDRESSPROOF")}</CustomLabel>
            </div>
            <SectionCardWrapper>
              <div style={{ marginBottom: "22px" }}>
                <CustomLabel
                  style={{ display: "block", paddingBottom: "12px" }}
                  font_size="14"
                >
                  Select any of the following documents
                </CustomLabel>
                <Select
                  // defaultValue={kyc_document.KYCADDRESSPROOF[0].value}
                  placeholder="Select below option"
                  style={{ minWidth: "120px" }}
                  options={kyc_document.KYCADDRESSPROOF}
                  onChange={(val) => onSelectClick(val, "kycdocs")}
                ></Select>
              </div>
              <div className="upload-card-wrapper">
                <UploadInput
                  onUpload={(e) => handleUploadKyc(e, kycdocs.length)}
                  style={{ margin: "0px 20px 0px 20px " }}
                  disabled={kycdocs.length >= 3}
                  title={
                    kycdocs.length !== 3
                      ? "Attach"
                      : "you have uploaded max docs"
                  }
                />
                <div className="upload-card-wrapper">
                  {kycdocs.map((item, i) => {
                    return (
                      <UploadInput
                        style={{ margin: "0px 10px 0px 0px " }}
                        title={item.filename}
                        value={item}
                        hideRemoveBtn={false}
                        onRemove={onRemoveKyc}
                        hideFileName={false}
                        doc_key={item.key}
                        key={"kycdocs" + i}
                      />
                    );
                  })}
                </div>
              </div>
            </SectionCardWrapper>
          </Col>
        )}
        <Col span={24} style={{ marginTop: "20px" }}>
          <FooterButton
            nextLabel={"Upload"}
            hideBack={true}
            disableNext={showUploadButton}
            onNext={() => onUpload()}
          />
        </Col>
      </Row>
    </div>
  );
};

export default withScroll(UploadPage);
